import "../../new.scss";
import { useState, useEffect, useContext } from "react";
import { ClientesFormContext } from '../../../context/clientes/ClientesContext';
import { useParams, useNavigate } from 'react-router-dom';
import { Tabs, Tab, Box } from '@mui/material';
import ProvinciasModal from '../../provincias/provinciasModal/provinciasModal';
import DepartamentosModal from '../../departamentos/departamentosModal/departamentosModal';
import LocalidadesModal from '../../localidades/localidadesModal/localidadesModal';
import BarriosModal from '../../barrios/barriosModal/barriosModal';
import IvaModal from '../../iva/ivaModal/ivaModal';
import CategoriasModal from '../../categoriasCliente/categoriasClienteModal/categoriasClienteModal';
import DocumentosModal from '../../documentos/documentosModal/documentosModal';
import EmpleadosModal from '../../empleados/empleadosModal/empleadosModal';
import ListasModal from '../../listascab/listasCabModal/listasCabModal';
import ConfirmationDialog from "../../../components/dialogs/ConfirmationDialog";
import ErrorDialog from "../../../components/dialogs/ErrorDialog";
import FormField from "../../../components/FormField/FormField";
import FormButtons from "../../../components/FormButtons/FormButtons";
import Inputs from "./configForm/inputs";
import { handleInputChange } from "./helpersForm/formHandlers";
import VisitaMapa from '../../../helpers/visitaMapa';

export const Form = ({ title }) => {
  const [form, setForm] = useState({});
  const {
    postClienteData,
    report,
    patchClienteData,
  } = useContext(ClientesFormContext);
  // Estado para controlar las pestañas
  const [tabIndex, setTabIndex] = useState(0);
  // id para edicion
  const { id } = useParams();
  const navigate = useNavigate();
  // Manejos de errores
  const [errors, setErrors] = useState({});
  //Estado de carga
  const [isSubmitting, setIsSubmitting] = useState(false);
  //Dialogs de confirmacion y error
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const [isErrorDialogOpen, setIsErrorDialogOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  //Estado para filtros 
  const [searchIdProvincia, setSearchIdProvincia] = useState();
  const [searchDescProvincia, setSearchDescProvincia] = useState('');
  const [searchIdDepartamento, setSearchIdDepartamento] = useState();
  const [searchDescDepartamento, setSearchDescDepartamento] = useState('');
  const [searchIdLocalidad, setSearchIdLocalidad] = useState();
  const [searchDescLocalidad, setSearchDescLocalidad] = useState('');
  const [searchIdBarrio, setSearchIdBarrio] = useState();
  const [searchDescBarrio, setSearchDescBarrio] = useState('');
  const [searchIdProvinciaEntrega, setSearchIdProvinciaEntrega] = useState();
  const [searchDescProvinciaEntrega, setSearchDescProvinciaEntrega] = useState('');
  const [searchIdDepartamentoEntrega, setSearchIdDepartamentoEntrega] = useState();
  const [searchDescDepartamentoEntrega, setSearchDescDepartamentoEntrega] = useState('');
  const [searchIdLocalidadEntrega, setSearchIdLocalidadEntrega] = useState();
  const [searchDescLocalidadEntrega, setSearchDescLocalidadEntrega] = useState('');
  const [searchIdBarrioEntrega, setSearchIdBarrioEntrega] = useState();
  const [searchDescBarrioEntrega, setSearchDescBarrioEntrega] = useState('');
  const [searchIdCategoria, setSearchIdCategoria] = useState();
  const [searchDescCategoria, setSearchDescCategoria] = useState('');
  const [searchIdIva, setSearchIdIva] = useState();
  const [searchDescIva, setSearchDescIva] = useState('');
  const [searchIdDocumento, setSearchIdDocumento] = useState();
  const [searchDescDocumento, setSearchDescDocumento] = useState('');
  const [searchIdEmpleado, setSearchIdEmpleado] = useState();
  const [searchDescEmpleado, setSearchDescEmpleado] = useState('');
  const [searchIdLista, setSearchIdLista] = useState();
  const [searchDescLista, setSearchDescLista] = useState('');

  const nameData = "clientes";
  const saveData = postClienteData;
  const updateData = patchClienteData;

  useEffect(() => {
    setIsSubmitting(false);
    if (report && Object.keys(report).length > 0) {
      setForm({
        ...report,
        cli_allow_edit: String(report.cli_allow_edit)
      });

      setSearchIdProvincia(report?.pcia_id ?? ""); // Si no existe, asigna una cadena vacía
      setSearchDescProvincia(report["prov-user"]?.["pcia_descripcion"] || "No se encuentra la provincia");

      setSearchIdDepartamento(report?.depto_id ?? "");
      setSearchDescDepartamento(report["dpto-user"]?.["depa_descripcion"] || "No se encuentra el departamento");

      setSearchIdLocalidad(report.loc_id ?? "");
      setSearchDescLocalidad(report["loc-user"]?.["loc_descripcion"] || "No se encuentra la localidad");

      setSearchIdBarrio(report.barrio_id ?? "");
      setSearchDescBarrio(report["barrio-user"]?.["barrrio_descripcion"] || "No se encuentra el barrio");

      setSearchIdProvinciaEntrega(report?.cli_pcia_entrega ?? ""); // Si no existe, asigna una cadena vacía
      setSearchDescProvinciaEntrega(report["prov-entrega-user"]?.["pcia_descripcion"] || "No se encuentra la provincia");

      setSearchIdDepartamentoEntrega(report?.cli_depto_entrega ?? "");
      setSearchDescDepartamentoEntrega(report["dpto-entrega-user"]?.["depa_descripcion"] || "No se encuentra el departamento");

      setSearchIdLocalidadEntrega(report.cli_loc_entrega ?? "");
      setSearchDescLocalidadEntrega(report["loc-entrega-user"]?.["loc_descripcion"] || "No se encuentra la localidad");

      setSearchIdBarrioEntrega(report.cli_barrio_entrega ?? "");
      setSearchDescBarrioEntrega(report["barrio-user"]?.["barrrio_descripcion"] || "No se encuentra el barrio");

      setSearchIdIva(report.tipoiva_id ?? "");
      setSearchDescIva(report["tipoiva"]?.["tiva_descripcion"] || "No se encuentra el tipo de IVA");

      setSearchIdDocumento(report.td_id ?? "");
      setSearchDescDocumento(report["tipo_doc_usuario"]?.["td_descripcion"] || "No se encuentra el documento");

      setSearchIdEmpleado(report.sel_id ?? "");
      setSearchDescEmpleado(report["el_empleado"]?.["nombre_completo"] || "No se encuentra el empleado");

      setSearchIdCategoria(report.categ_id ?? "");
      setSearchDescCategoria(report["la_categoria"]?.["categ_descripcion"] || "No se encuentra la categoría");

      setSearchIdLista(report.lp_id ?? "");
      setSearchDescLista(report["cli_lista"]?.["lp_descripcion"] || "No se encuentra la lista");
    }
  }, [report]);

  useEffect(() => {
    setIsSubmitting(false);
    if (searchIdProvincia) {
      setForm((prevForm) => ({
        ...prevForm,
        pcia_id: searchIdProvincia, // Asegura que tipoiva_id se actualice si hay descripción
      }));
    } else if (!searchDescProvincia) {
      setSearchIdProvincia();
      setSearchIdDepartamento();
      setSearchIdLocalidad();
      setSearchDescProvincia();
      setSearchDescDepartamento();
      setSearchDescLocalidad();
      setForm((prevForm) => ({
        ...prevForm,
        pcia_id: null, // Establece la clave con un valor vacío en lugar de eliminarla
      }));
    }
  }, [searchDescProvincia, searchIdProvincia]);

  useEffect(() => {
    setIsSubmitting(false);
    if (searchIdDepartamento) {
      setForm((prevForm) => ({
        ...prevForm,
        depto_id: searchIdDepartamento,
      }));
    } else if (!searchDescDepartamento) {
      setSearchIdDepartamento();
      setSearchIdLocalidad();
      setSearchDescDepartamento();
      setForm((prevForm) => ({
        ...prevForm,
        depto_id: null, // Establece la clave con un valor vacío en lugar de eliminarla

      }));
    }
  }, [searchDescDepartamento, searchIdDepartamento]);

  useEffect(() => {
    setIsSubmitting(false);
    if (searchIdLocalidad) {
      setForm((prevForm) => ({
        ...prevForm,
        loc_id: searchIdLocalidad,
      }));
    } else if (!searchDescLocalidad) {
      setSearchIdLocalidad();
      setSearchDescLocalidad();
      setForm((prevForm) => ({
        ...prevForm,
        loc_id: null, // Establece la clave con un valor vacío en lugar de eliminarla

      }));
    }
  }, [searchDescLocalidad, searchIdLocalidad]);

  useEffect(() => {
    setIsSubmitting(false);
    if (searchIdBarrio) {
      setForm((prevForm) => ({
        ...prevForm,
        barrio_id: searchIdBarrio,
      }));
    } else if (!searchDescBarrio) {
      setSearchIdBarrioEntrega();
      setSearchDescBarrioEntrega();
      setForm((prevForm) => ({
        ...prevForm,
        barrio_id: null, // Establece la clave con un valor vacío en lugar de eliminarla

      }));
    }
  }, [searchDescBarrio, searchIdBarrio]);



  useEffect(() => {
    setIsSubmitting(false);
    if (searchIdIva) {
      setForm((prevForm) => ({
        ...prevForm,
        tipoiva_id: searchIdIva, // Asegura que tipoiva_id se actualice si hay descripción
      }));
    } else if (!searchDescIva) {
      setSearchIdIva();
      setForm((prevForm) => ({
        ...prevForm,
        tipoiva_id: null, // Establece la clave con un valor vacío en lugar de eliminarla
      }));
    }
  }, [searchDescIva, searchIdIva]);

  useEffect(() => {
    setIsSubmitting(false);
    if (searchIdCategoria !== undefined && searchIdCategoria !== null && searchIdCategoria !== "") {
      setForm((prevForm) => ({
        ...prevForm,
        categ_id: searchIdCategoria,
      }));
    } else if (!searchDescCategoria) {
      setSearchIdCategoria();
      setForm((prevForm) => ({
        ...prevForm,
        categ_id: null,
      }));
    }
  }, [searchDescCategoria, searchIdCategoria]);
  useEffect(() => {
    setIsSubmitting(false);
    if (searchIdDocumento) {
      setForm((prevForm) => ({
        ...prevForm,
        td_id: searchIdDocumento, // Asegura que tipoiva_id se actualice si hay descripción
      }));
    } else if (!searchDescDocumento) {
      setSearchIdDocumento();
      setForm((prevForm) => ({
        ...prevForm,
        td_id: null, // Establece la clave con un valor vacío en lugar de eliminarla
      }));
    }
  }, [searchDescDocumento, searchIdDocumento]);
  useEffect(() => {
    setIsSubmitting(false);
    if (searchIdEmpleado) {
      setForm((prevForm) => ({
        ...prevForm,
        sel_id: searchIdEmpleado, // Asegura que tipoiva_id se actualice si hay descripción
      }));
    } else if (!searchDescEmpleado) {
      setSearchIdEmpleado();
      setForm((prevForm) => ({
        ...prevForm,
        sel_id: null, // Establece la clave con un valor vacío en lugar de eliminarla
      }));
    }
  }, [searchDescEmpleado, searchIdEmpleado]);


  useEffect(() => {
    setIsSubmitting(false);
    if (searchIdProvinciaEntrega) {
      setForm((prevForm) => ({
        ...prevForm,
        cli_pcia_entrega: searchIdProvinciaEntrega, // Asegura que tipoiva_id se actualice si hay descripción
      }));
    } else if (!searchDescProvinciaEntrega) {
      setSearchIdProvinciaEntrega();
      setSearchIdDepartamentoEntrega();
      setSearchIdLocalidadEntrega();
      setSearchDescProvinciaEntrega();
      setSearchDescDepartamentoEntrega();
      setSearchDescLocalidadEntrega();
      setForm((prevForm) => ({
        ...prevForm,
        cli_pcia_entrega: null, // Establece la clave con un valor vacío en lugar de eliminarla
      }));
    }
  }, [searchDescProvinciaEntrega, searchIdProvinciaEntrega]);

  useEffect(() => {
    setIsSubmitting(false);
    if (searchIdDepartamentoEntrega) {
      setForm((prevForm) => ({
        ...prevForm,
        cli_depto_entrega: searchIdDepartamentoEntrega,
      }));
    } else if (!searchDescDepartamentoEntrega) {
      setSearchIdDepartamentoEntrega();
      setSearchIdLocalidadEntrega();
      setSearchDescDepartamentoEntrega();
      setForm((prevForm) => ({
        ...prevForm,
        cli_depto_entrega: null, // Establece la clave con un valor vacío en lugar de eliminarla

      }));
    }
  }, [searchDescDepartamentoEntrega, searchIdDepartamentoEntrega]);

  useEffect(() => {
    setIsSubmitting(false);
    if (searchIdLocalidadEntrega) {
      setForm((prevForm) => ({
        ...prevForm,
        cli_loc_entrega: searchIdLocalidadEntrega,
      }));
    } else if (!searchDescLocalidadEntrega) {
      setSearchIdLocalidadEntrega();
      setSearchDescLocalidadEntrega();
      setForm((prevForm) => ({
        ...prevForm,
        cli_loc_entrega: null, // Establece la clave con un valor vacío en lugar de eliminarla

      }));
    }
  }, [searchDescLocalidadEntrega, searchIdLocalidadEntrega]);

  useEffect(() => {
    setIsSubmitting(false);
    if (searchIdBarrioEntrega) {
      setForm((prevForm) => ({
        ...prevForm,
        cli_barrio_entrega: searchIdBarrioEntrega,
      }));
    } else if (!searchDescBarrioEntrega) {
      setSearchIdBarrioEntrega();
      setSearchDescBarrioEntrega();
      setForm((prevForm) => ({
        ...prevForm,
        cli_barrio_entrega: null, // Establece la clave con un valor vacío en lugar de eliminarla
      }));
    }
  }, [searchDescBarrioEntrega, searchIdBarrioEntrega]);
  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  const handleChange = (e) => {
    handleInputChange(e, setForm, Inputs, setErrors, form);
  };

  const validateForm = () => {
    let formErrors = {};
    Inputs.forEach(({ name, validation }) => {
      if (validation) {
        const error = validation(form[name] || "", form);
        if (error) formErrors[name] = error;
      }
    });
    setErrors(formErrors);
    return !Object.keys(formErrors).length;
  };

  const openConfirmDialog = () => setIsConfirmDialogOpen(true);
  const closeConfirmDialog = () => setIsConfirmDialogOpen(false);

  const openErrorDialog = (message) => {
    setErrorMessage(message);
    setIsErrorDialogOpen(true);
  };
  const closeErrorDialog = () => setIsErrorDialogOpen(false);


  // Enviar datos
  const handleSendData = () => {
    if (!validateForm()) {
      // Usamos un callback para asegurarnos de que `errors` esté actualizado
      setErrors((prevErrors) => {
        const errorMessagesArray = Inputs.reduce((acc, { name, label }) => {
          if (prevErrors[name]) {
            const fieldLabel = label || name; // Usar el label si existe, si no, usar el nombre del campo
            acc.push(`${fieldLabel}: ${prevErrors[name]}`);
          }
          return acc;
        }, []);
        // Solo abrimos el diálogo de error cuando se hayan generado los mensajes
        if (errorMessagesArray.length > 0) {
          openErrorDialog(errorMessagesArray);
        }

        return prevErrors; // No modificamos el estado aquí
      });

      return;
    }
    openConfirmDialog();
  };

  const confirmSendData = async () => {
    setIsSubmitting(true);
    closeConfirmDialog(); try {
      if (id) {
        await updateData(id, form);
      } else {
        await saveData(form);
      }
      navigate(`/${nameData}`);
    } catch (error) {
      console.error(error);
      openErrorDialog("Error al guardar los datos. Intenta nuevamente.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancel = () => {
    navigate(`/${nameData}`);
  };
  return (
    <div className="new">
      <div className="newContainer">
        <div className="top">
          <h1>{title}</h1>
        </div>
        <div className="bottom">
          <div className="right">
            <Tabs value={tabIndex} onChange={handleTabChange}>
              <Tab label="Datos Personales" />
              <Tab label="Perfil Comercial" />
              <Tab label="Acceso a Pagina Web" />
              <Tab label="Acceso a Pagina App" />
              <Tab label="Direccion Principal" />
              <Tab label="Direccion de Entrega" />
              {form.cli_gps_latitud !== null && form.cli_gps_latitud !== undefined && form.cli_gps_latitud !== "" &&
                <Tab label="Ubicacion Geografica" />}
            </Tabs>
            {/* TAB GENERAL*/}
            <Box sx={{ padding: 2 }}>
              {/* TAB 0 */}
              {tabIndex === 0 && (
                <>
                  <form>
                    {Inputs.slice(0, 10).map((input) => {
                      if (input.name === "tipoiva_id") {
                        return (
                          <div className="formInput" key={input.id}>
                            <label>{input.label}</label>
                            <IvaModal
                              handleChange={setSearchIdIva}
                              handleDescChange={setSearchDescIva}
                              descSelected={searchDescIva}
                            />
                            {errors[input.name] && <p className="error">{errors[input.name]}</p>}
                          </div>
                        );
                      } else if (input.name === "td_id") {
                        return (
                          <div className="formInput" key={input.id}>
                            <label>{input.label}</label>
                            <DocumentosModal
                              handleChange={setSearchIdDocumento}
                              handleDescChange={setSearchDescDocumento}
                              descSelected={searchDescDocumento}
                            />
                            {errors[input.name] && <p className="error">{errors[input.name]}</p>}
                          </div>
                        );
                      } else {
                        return (
                          <FormField
                            key={input.id}
                            input={input}
                            value={form[input.name] || ""}
                            handleInputChange={(e) =>
                              handleInputChange(e, setForm, Inputs, setErrors, form)
                            }
                            error={errors[input.name]}
                          />
                        );
                      }
                    })}
                  </form>
                </>
              )}

              {tabIndex === 1 && (
                <>
                  <form>
                    {Inputs.slice(10, 14).map((input) => {
                      if (input.name === "sel_id") {
                        return (
                          <div className="formInput" key={input.id}>
                            <label>{input.label}</label>
                            <EmpleadosModal
                              handleChange={setSearchIdEmpleado}
                              handleDescChange={setSearchDescEmpleado}
                              descSelected={searchDescEmpleado}
                            />
                            {errors[input.name] && <p className="error">{errors[input.name]}</p>}
                          </div>
                        );
                      } else if (input.name === "lp_id") {
                        return (
                          <div className="formInput" key={input.id}>
                            <label>{input.label}</label>
                            <ListasModal
                              handleChange={setSearchIdLista}
                              handleDescChange={setSearchDescLista}
                              descSelected={searchDescLista}
                            />
                            {errors[input.name] && <p className="error">{errors[input.name]}</p>}
                          </div>
                        );
                      } else if (input.name === "categ_id") {
                        return (
                          <div className="formInput" key={input.id}>
                            <label>{input.label}</label>
                            <CategoriasModal
                              handleIDChange={setSearchIdCategoria}
                              handleDescChange={setSearchDescCategoria}
                              descSelected={searchDescCategoria}
                            />
                            {errors[input.name] && <p className="error">{errors[input.name]}</p>}
                          </div>
                        );
                      } else if (input.name === "tipoiva_id") {
                        return (
                          <div className="formInput" key={input.id}>
                            <label>{input.label}</label>
                            <IvaModal
                              handleChange={setSearchIdIva}
                              handleDescChange={setSearchDescIva}
                              descSelected={searchDescIva}
                            />
                            {errors[input.name] && <p className="error">{errors[input.name]}</p>}
                          </div>
                        );
                      } else {
                        return (
                          <FormField
                            key={input.id}
                            input={input}
                            value={form[input.name] || ""}
                            handleInputChange={(e) =>
                              handleInputChange(e, setForm, Inputs, setErrors, form)
                            }
                            error={errors[input.name]}
                          />
                        );
                      }
                    })}
                  </form>
                </>
              )}

              {tabIndex === 2 && (
                <>
                  <form>
                    {Inputs.slice(14, 16).map((input) => {

                      return (
                        <FormField
                          key={input.id}
                          input={input}
                          value={form[input.name] || ""}
                          handleInputChange={(e) =>
                            handleInputChange(e, setForm, Inputs, setErrors, form)
                          }
                          error={errors[input.name]}
                        />
                      );

                    })}
                  </form>
                </>
              )}

              {tabIndex === 3 && (
                <>
                  <form>
                    {Inputs.slice(16, 17).map((input) => {

                      return (
                        <FormField
                          key={input.id}
                          input={input}
                          value={form[input.name] || ""}
                          handleInputChange={(e) =>
                            handleInputChange(e, setForm, Inputs, setErrors, form)
                          }
                          error={errors[input.name]}
                        />
                      );

                    })}
                  </form>
                </>
              )}

              {/* TAB 1 */}
              {tabIndex === 4 && (
                <>
                  <form>
                    {Inputs.slice(17, 27).map((input) => {
                      if (input.name === "pcia_id") {
                        return (
                          <div className="formInput" key={input.id}>
                            <label>{input.label}</label>
                            <ProvinciasModal
                              handleChange={setSearchIdProvincia}
                              handleDescChange={setSearchDescProvincia}
                              descSelected={searchDescProvincia}
                              handleDepaChange={setSearchIdDepartamento}
                              handleLocChange={setSearchIdLocalidad}
                            />
                            {errors[input.name] && <p className="error">{errors[input.name]}</p>}
                          </div>
                        );
                      } else if (input.name === "depto_id") {
                        return (
                          <div className="formInput" key={input.id}>
                            <label>{input.label}</label>
                            <DepartamentosModal
                              handleChange={setSearchIdDepartamento}
                              handleDescChange={setSearchDescDepartamento}
                              descSelected={searchDescDepartamento}
                              idSelectorProv={searchIdProvincia}
                            />
                            {errors[input.name] && <p className="error">{errors[input.name]}</p>}
                          </div>
                        );
                      } else if (input.name === "loc_id") {
                        return (
                          <div className="formInput" key={input.id}>
                            <label>{input.label}</label>
                            <LocalidadesModal
                              handleChange={setSearchIdLocalidadEntrega}  // ← Corregido
                              handleDescChange={setSearchDescLocalidadEntrega}
                              descSelected={searchDescLocalidadEntrega}
                              idSelectorProv={searchIdProvinciaEntrega}
                              idSelectorDepto={searchIdDepartamentoEntrega}
                            />
                            {errors[input.name] && <p className="error">{errors[input.name]}</p>}
                          </div>
                        );
                      } else if (input.name === "barrio_id") {
                        return (
                          <div className="formInput" key={input.id}>
                            <label>{input.label}</label>
                            <BarriosModal
                              handleChange={setSearchIdBarrio}
                              handleDescChange={setSearchDescBarrio}
                              descSelected={searchDescBarrio}
                              idSelectorLoc={searchIdLocalidad}
                            />
                            {errors[input.name] && <p className="error">{errors[input.name]}</p>}
                          </div>
                        );
                      } else {
                        return (
                          <FormField
                            key={input.id}
                            input={input}
                            value={form[input.name] || ""}
                            handleInputChange={(e) =>
                              handleInputChange(e, setForm, Inputs, setErrors, form)
                            }
                            error={errors[input.name]}
                          />
                        );
                      }
                    })}
                  </form>
                </>
              )}

              {/* TAB 1 */}
              {tabIndex === 5 && (
                <>
                  <form>
                    {Inputs.slice(27, 37).map((input) => {
                      if (input.name === "cli_pcia_entrega") {
                        return (
                          <div className="formInput" key={input.id}>
                            <label>{input.label}</label>
                            <ProvinciasModal
                              handleChange={setSearchIdProvinciaEntrega}
                              handleDescChange={setSearchDescProvinciaEntrega}
                              descSelected={searchDescProvinciaEntrega}
                              handleDepaChange={setSearchIdDepartamentoEntrega}
                              handleLocChange={setSearchIdLocalidadEntrega}
                            />
                            {errors[input.name] && <p className="error">{errors[input.name]}</p>}
                          </div>
                        );
                      } else if (input.name === "cli_depto_entrega") {
                        return (
                          <div className="formInput" key={input.id}>
                            <label>{input.label}</label>
                            <DepartamentosModal
                              handleChange={setSearchIdDepartamentoEntrega}
                              handleDescChange={setSearchDescDepartamentoEntrega}
                              descSelected={searchDescDepartamentoEntrega}
                              idSelectorProv={searchIdProvinciaEntrega}
                            />
                            {errors[input.name] && <p className="error">{errors[input.name]}</p>}
                          </div>
                        );
                      } else if (input.name === "cli_loc_entrega") {
                        return (
                          <div className="formInput" key={input.id}>
                            <label>{input.label}</label>
                            <LocalidadesModal
                              handleChange={setSearchIdLocalidad}
                              handleDescChange={setSearchDescLocalidadEntrega}
                              descSelected={searchDescLocalidadEntrega}
                              idSelectorProv={searchIdProvinciaEntrega}
                              idSelectorDepto={searchIdDepartamentoEntrega}
                            />
                            {errors[input.name] && <p className="error">{errors[input.name]}</p>}
                          </div>
                        );
                      } else if (input.name === "cli_barrio_entrega") {
                        return (
                          <div className="formInput" key={input.id}>
                            <label>{input.label}</label>
                            <BarriosModal
                              handleChange={setSearchIdBarrioEntrega}
                              handleDescChange={setSearchDescBarrioEntrega}
                              descSelected={searchDescBarrioEntrega}
                              idSelectorLoc={searchIdLocalidadEntrega}
                            />
                            {errors[input.name] && <p className="error">{errors[input.name]}</p>}
                          </div>
                        );
                      } else {
                        return (
                          <FormField
                            key={input.id}
                            input={input}
                            value={form[input.name] ?? ""}
                            handleInputChange={(e) =>
                              handleInputChange(e, setForm, Inputs, setErrors, form)
                            }
                            error={errors[input.name]}
                          />
                        );
                      }
                    })}
                  </form>
                </>
              )}
              {/* TAB 1 */}
              {(tabIndex === 6) && (
                <>
                  <div style={{ marginTop: "20px" }}>
                    <h3>Ubicaciones en Mapa</h3>
                    <VisitaMapa
                      latCliente={form.cli_gps_latitud}
                      lonCliente={form.cli_gps_longitud}
                      tienePedido={form.cli_estado_pedido}
                    />
                  </div>
                  <form>
                    {Inputs.slice(37, 39).map((input) => {

                      return (
                        <FormField
                          key={input.id}
                          input={input}
                          value={form[input.name] || ""}
                          handleInputChange={(e) =>
                            handleInputChange(e, setForm, Inputs, setErrors, form)
                          }
                          error={errors[input.name]}
                        />
                      );

                    })}
                  </form>
                </>

              )}


            </Box>

            <form> </form>
            <FormButtons
              isSubmitting={isSubmitting}
              handleSave={handleSendData}
              handleCancel={handleCancel}
              saveText="Guardar"
              cancelText="Cancelar"
            />


            <ConfirmationDialog
              isOpen={isConfirmDialogOpen}
              onClose={closeConfirmDialog}
              onConfirm={confirmSendData}
              title=""
              message="¿Estás seguro de que deseas guardar este registro?"
            />
            <ErrorDialog
              isOpen={isErrorDialogOpen}
              onClose={closeErrorDialog}
              messages={errorMessage}
              title=""
            />
          </div>
        </div>
      </div>
    </div >
  );
};
export default Form;
